module.exports = __webpack_public_path__ + "static/media/Radisson_Blue_Hotel.9c8f06b7.mp4";